/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-12-06 14:06:13
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2023-01-05 11:23:08
 * @FilePath: \ioc_base\src\modules\personAuthorization\config\groupTable.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import i18n from "@src/common/lib/i18n";
import utils from "@src/common/utils";
import { Dic } from "$utils";
export const migrantsTable = function () {
  return {
    add: "新增",
    edit: "修改",
    view: "查看",
    page: true,
    selection: false,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: "：",
    size: "small",
    maxHeight: "100%",
    labelWidth: "120px",
    menuAlign: "center",
    labelPosition: "right",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 200,
    dialogWidth: "400px",
    viewDialogWidth: "700px",
    viewDialogHeight: 450,
    emptyText: i18n.t("personAccess.title.noData"),
    highlightCurrentRow: true,
    menu: false,
    column: [
      {
        label: "权限组",
        prop: "thirdRightGroupName"
      },
      {
        label: "姓名",
        prop: "name",
        search: true,
        clearable: true
      },
      {
        label: "电话",
        prop: "phone"
      },
      {
        label: "性别",
        prop: "sex",
        formatter: function (row, value) {
          return Dic.findByValue("SENU092", value);
        }
      },
      {
        label: "生效时间",
        prop: "effectiveTime"
      },
      {
        label: "失效时间",
        prop: "expirationTime"
      }
    ]
  };
};
